// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"57151336","239":"6325e17c","732":"975c07e9"}[chunkId] + ".chunk.js";
};